module.exports = __webpack_public_path__ + "img/23.4c7587f3.png";